import { usePagination, useSearch, useSorting } from "@/hooks";
import { GetCompaniesParams } from "@/redux/apis/company/types";

export const useGetCompaniesParams = () => {
  const [search, setSearch] = useSearch();
  const { page, pageSize } = usePagination();
  const { sortKey, direction } = useSorting();

  const params: GetCompaniesParams = {
    page,
    page_size: pageSize,
    sort: sortKey,
    direction,
    search,
  };

  return { params, page, pageSize, sort: sortKey, direction, search, setSearch };
};
